import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/cq/pure-coupon',
    name: 'cqPureConpo',
    component: () =>
      import(/* webpackChunkName: "cqPureConpo" */ '@/views/cq/activities/pure-coupon.vue'),
    meta: {
      cname: '清明活动'
    }
  },
  {
    path: '/cq/activity/labour-day',
    name: 'cqLabourDay',
    component: () =>
      import(/* webpackChunkName: "cqLabourDay" */ '@/views/cq/activities/LabourDay.vue'),
    meta: {
      cname: '五一活动'
    }
  },
  {
    path: '/cq/activity/dragon-day',
    name: 'cqDragonDay',
    component: () =>
      import(/* webpackChunkName: "cqDragonDay" */ '@/views/cq/activities/DragonDay.vue'),
    meta: {
      cname: '端午活动'
    }
  },
  {
    path: '/cq/activity/qx',
    name: 'cqQX',
    component: () => import(/* webpackChunkName: "cqQX" */ '@/views/cq/activities/QiXi.vue'),
    meta: {
      cname: '七夕活动'
    }
  },
  {
    path: '/cq/activity/national-kind',
    name: 'cqNationalKind',
    component: () =>
      import(/* webpackChunkName: "cqNationalKind" */ '@/views/cq/activities/NationalDaykind.vue'),
    meta: {
      cname: '国庆亲情钥匙活动'
    }
  },
  {
    path: '/cq/activity/national-vip',
    name: 'cqNationalVip',
    component: () =>
      import(/* webpackChunkName: "cqNationalVip" */ '@/views/cq/activities/NationalDayVip.vue'),
    meta: {
      cname: '国庆会员活动'
    }
  },
  {
    path: '/cq/activity/summer-day/:mode',
    name: 'cqSummerDay',
    component: () =>
      import(/* webpackChunkName: "cqSummerDay" */ '@/views/cq/activities/SummerDay.vue'),
    meta: {
      cname: '夏季活动'
    }
  },
  {
    path: '/activity/nfc-intro',
    name: 'nfcIntro',
    component: () => import(/* webpackChunkName: "nfcIntro" */ '@/views/cq/NFCIntro.vue'),
    meta: {
      cname: 'nfc介绍'
    }
  },
  {
    path: '/activity/month-report',
    name: 'monthReport',
    component: () =>
      import(/* webpackChunkName: "monthReport" */ '@/views/cq/activities/monthSum/index.vue'),
    meta: {
      cname: '乘趣月报'
    }
  },
  {
    path: '/cq/activity/month-recommand',
    name: 'monthRecommand',
    component: () =>
      import(
        /* webpackChunkName: "monthRecommand" */ '@/views/cq/activities/monthSum/MonthRecommend.vue'
      ),
    meta: {
      cname: '乘趣月报'
    }
  },
  {
    path: '/activity/year-report',
    name: 'yearReport',
    component: () =>
      import(/* webpackChunkName: "yearReport" */ '@/views/cq/activities/2025-report/YearPort.vue'),
    meta: {
      cname: '年报说明'
    }
  },
  {
    path: '/cq/activity/middle-year',
    name: 'cqMiddleYear',
    component: () =>
      import(/* webpackChunkName: "cqMiddleYear" */ '@/views/cq/activities/MiddleYear.vue'),
    meta: {
      cname: '乘趣618'
    }
  },
  {
    path: '/cq/activity/month-recommand-detail',
    name: 'monthRecommandDetail',
    component: () =>
      import(
        /* webpackChunkName: "monthRecommandDetail" */ '@/views/cq/activities/monthSum/RecommandDetail.vue'
      ),
    meta: {
      cname: '乘趣月报推荐详情'
    }
  },
  {
    path: '/cq/activity/double-11',
    name: 'double11',
    component: () =>
      import(/* webpackChunkName: "double11" */ '@/views/cq/activities/Double11.vue'),
    meta: {
      cname: '乘趣双11'
    }
  },
  {
    path: '/cq/sms-notice',
    name: 'smsNotice',
    component: () => import(/* webpackChunkName: "smsNotice" */ '@/views/cq/SmsNotice.vue'),
    meta: {
      cname: '乘趣短信通知'
    }
  },
  {
    path: '/cq/activity/2025-report',
    name: '2025Report',
    component: () =>
      import(/* webpackChunkName: "2025Report" */ '@/views/cq/activities/2025-report/2025-sum.vue'),
    meta: {
      cname: '乘趣2025年报'
    }
  },
  {
    path: '/cq/activity/recruit',
    name: 'cqRecruit',
    component: () =>
      import(/* webpackChunkName: "cqRecruit" */ '@/views/cq/activities/Recruit.vue'),
    meta: {
      cname: '乘趣2025招聘'
    }
  },
  {
    path: '/cq/feedback',
    name: 'cqFeedback',
    component: () =>
      import(/* webpackChunkName: "cqFeedback" */ '@/views/cq/feedback/Feedback.vue'),
    meta: {
      cname: '意见反馈'
    }
  },
  {
    path: '/cq/feedback-success',
    name: 'cqFeedbackSuccess',
    component: () =>
      import(/* webpackChunkName: "cqFeedbackSuccess" */ '@/views/cq/feedback/FeedbackSuccess.vue'),
    meta: {
      cname: '反馈成功'
    }
  },
  {
    // 个人信息收集清单
    path: '/personCollect',
    name: 'personCollect',
    component: () => import(/* webpackChunkName: "personCollect" */ '@/views/cq/PersonCollect.vue'),
    meta: {
      cname: '个人信息收集清单'
    }
  },
  {
    // 用户服务协议
    path: '/paRegist',
    name: 'paRegist',
    component: () =>
      import(/* webpackChunkName: "Agreements" */ '@/views/cq/agreements/Agreements.vue')
  },
  {
    // 常见问题
    path: '/commonProblems',
    name: 'commonProblems',
    component: () =>
      import(/* webpackChunkName: "CustomerService" */ '@/views/cq/help-center/IndexView.vue'),
    meta: {
      cname: '帮助中心'
    }
  },
  {
    // 问题详情
    path: '/commonProblems/detail',
    name: 'commonProblemsDetailv2',
    component: () =>
      import(
        /* webpackChunkName: "CustomerServiceDetail" */ '@/views/cq/help-center/DetailView.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    // SKILL 密钥管理
    path: '/cq/skill-apikey',
    name: 'skillApikey',
    component: () => import(/* webpackChunkName: "SkillApikey" */ '@/views/cq/skill-apikey/Index.vue'),
    meta: {
      cname: 'SKILL'
    }
  },
  // 连续续费协议
  {
    path: '/cq/buyservice/agreement',
    name: 'buyserviceAgreement',
    component: () =>
      import(/* webpackChunkName: "BuyserviceAgreement" */ '@/views/cq/buyservice/Agreeement.vue'),
    meta: {
      cname: '连续续费协议'
    }
  },
  {  
    path: '/cq/transfer',
    name: 'transfer',
    component: () => import(/* webpackChunkName: "transfer" */ '@/views/cq/PageHub.vue'),
    meta: {
      cname: '中转'
    }
  },
  {
    path: '/cq/sm',
    name: 'smDetail',
    component: () => import(/* webpackChunkName: "smDetail" */ '@/views/cq/support-model/IndexView.vue'),
    meta: {
      cname: '支持的车型'
    }
  },
  {
    path: '/cq/sm/detail',
    name: 'smDetailView',
    component: () => import(/* webpackChunkName: "smDetailView" */ '@/views/cq/support-model/DetailView.vue'),
    meta: {
      cname: '安装说明'
    }
  },
  {
    path: '/cq/sm/search',
    name: 'smSearch',
    component: () => import(/* webpackChunkName: "smSearch" */ '@/views/cq/support-model/SearchView.vue'),
    meta: {
      cname: '数字鑰匙查询'
    }
  },
  {
    path: '/cq/sm/pdf',
    name: 'smPdf',
    component: () => import(/* webpackChunkName: "smPdf" */ '@/views/cq/support-model/PdfView.vue'),
    meta: {
      cname: '查看说明书'
    }
  },
  {
    path: '/cq/sm/video',
    name: 'smVideo',
    component: () => import(/* webpackChunkName: "smVideo" */ '@/views/cq/support-model/VideoView.vue'),
    meta: {
      cname: '查看视频'
    }
  },
   {
    path: '/cq/activity/2026618',
    name: 'cq2026618',
    component: () => import(/* webpackChunkName: "cq2026618" */ '@/views/cq/activities/IndexYearMiddle.vue'),
    meta: {
      cname: '查看视频'
    }
  },
  {
    path: '/cq/activity/start-ac',
    name: 'cqStartAc',
    component: () =>
      import(/* webpackChunkName: "cqStartAc" */ '@/views/cq/activities/StartAc.vue'),
    meta: {
      cname: '开启空调活动'
    }
  },
  {
    path: '/cq/questionnaire/:type',
    name: 'cqQuestionnaire',
    component: () =>
      import(/* webpackChunkName: "cqQuestionnaire" */ '@/views/cq/questionnaire/Questionnaire.vue'),
    meta: {
      cname: '问卷'
    }
  },
  {
    path: '/cq/questionnaire-success',
    name: 'cqQuestionnaireSuccess',
    component: () =>
      import(
        /* webpackChunkName: "cqQuestionnaireSuccess" */ '@/views/cq/questionnaire/QuestionnaireSuccess.vue'
      ),
    meta: {
      cname: '问卷已提交'
    }
  },
  {
    path: '/cq/activity/2026double11',
    name: 'cq2026Double11',
    component: () =>
      import(
        /* webpackChunkName: "cq2026Double11" */ '@/views/cq/activities/Double11_2026.vue'
      ),
    meta: {
      cname: '乘趣2026双11'
    }
  },
];
export default routes;
